import { render, staticRenderFns } from "./EmdPagarmeIcon.vue?vue&type=template&id=78cfea1e&"
import script from "./EmdPagarmeIcon.vue?vue&type=script&lang=js&"
export * from "./EmdPagarmeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports